@if(showCookies()){
    <div class="cookies-container" @fadeSlide>
        <div class="cookies-wrapper">
            <p>Le informamos que este portal web solo utiliza cookies que no requieren el consentimiento de los usuarios al tener una finalidad técnica, y que, por tanto, están exceptuadas del cumplimiento de las obligaciones establecidas en el artículo 22.2 de la Ley de Servicios de la Sociedad de la Información y Comercio Electrónico. Para más información sobre las cookies utilizadas, visita la <u (click)="goToCookiesPolicy()">Política de Cookies.</u></p>

            <button (click)="acceptCookies()">Aceptar las cookies</button>
        </div>
    </div>
}